import Vue from 'vue';
import VueScrollto from 'vue-scrollto';
import {
  Select,
  Option,
  Input,
  Form,
  FormItem,
  DatePicker,
  Button,
  Pagination,
  Switch,
  Dialog,
  Progress,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Icon,
  Tooltip,
  Tabs,
  TabPane,
  Menu,
  Submenu,
  MenuItem,
  Loading,
  MessageBox,
  Notification,
  Message,
  Table,
  TableColumn,
  Collapse,
  CollapseItem,
  Autocomplete,
  Tag,
  Popover,
  CollapseTransition,
  Row,
  Col,
  Cascader,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'element-ui';

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(VueScrollto);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
Vue.use(Tooltip);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Loading.directive);
Vue.use(Autocomplete);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Row);
Vue.use(Col);
Vue.use(Cascader);
Vue.component(CollapseTransition.name, CollapseTransition);


Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;



// WEBPACK FOOTER //
// ./src/vendor.js